import {getDate} from '../../../../../../@casino/lib/getDate';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    wrapBlock: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12
    },
    wrapSwitch: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165,
    },
    manually: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165, 
        color: '#fff'
    },
    spo: {
        width: 40, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        background: '#141b33',
        color: '#fff',
        boxShadow: '4px 4px 8px 0px rgb(34 60 80 / 20%)',
    },
    datetime: {
        border: 'none', 
        outline: 'none', 
        paddingLeft: 15, 
        borderRadius: 4, 
        background: '#34488c',
        color: '#fff'
    },
}));

const rowsHistory = (history) => {
    return  history.data.map((item) => {
        return {
            id: item.id,
            login: item.login,
            bonus_name: item.bonus_name,
            date_event: getDate(+item.date_event),
            cause: item.cause ? item.cause : '-',
        }
    })
} 

const columnsHistory = [
    { id: 'id', label: 'ID игрока'},
    { id: 'login', label: 'Логин пользвателя'},
    { id: 'bonus_name', label: 'Имя бонуса'},
    { id: 'date_event', label: 'Дата выдачи'},
    { id: 'cause', label: 'Причина выдачи'},
]

export {
    useStyles,
    rowsHistory,
    columnsHistory
}